import React from "react";
import { ClockIcon } from "lucide-react";
import { services } from "../../data/services";
import type { ServiceCategory } from "../../types/booking";
const groups: Array<{
  category: ServiceCategory;
  title: string;
  hint: string;
}> = [{
  category: "prescription",
  title: "Sur ordonnance",
  hint: "Kinésithérapie remboursée par l'Assurance Maladie"
}, {
  category: "wellness",
  title: "Sans ordonnance",
  hint: "Prévention et bien-être, accessibles à tous"
}];
interface ServiceStepProps {
  selectedId: string | null;
  onSelect: (id: string) => void;
}
export function ServiceStep({
  selectedId,
  onSelect
}: ServiceStepProps) {
  return <div data-id="element-123" data-mp="106hqxtu32z38">
      <h2 className="text-xl font-semibold text-ink" data-id="element-124" data-mp="107subsjma4tt">Quel soin souhaitez-vous ?</h2>
      <div className="mt-6 space-y-8" data-id="element-125" data-mp="154156tqs7bv6">
        {groups.map(group => <fieldset key={group.category} data-id="element-126" data-mp="1a4yl0zobjtti">
            <legend className="text-sm font-semibold text-ink" data-id="element-127" data-mp="1a22nhcgdv75l">{group.title}</legend>
            <p className="text-xs text-muted" data-id="element-128" data-mp="1f38gzchvayg6">{group.hint}</p>
            <div role="radiogroup" aria-label={group.title} className="mt-3 space-y-2" data-id="element-129" data-mp="n8rivxucu3yd">
              {services.filter(s => s.category === group.category).map(service => {
            const selected = service.id === selectedId;
            return <button key={service.id} type="button" role="radio" aria-checked={selected} onClick={() => onSelect(service.id)} className={`flex w-full items-start gap-4 rounded-2xl border p-4 text-left transition-colors duration-150 sm:p-5 ${selected ? "border-brand bg-brand-soft" : "border-line hover:border-brand/40"}`} data-id="element-130" data-mp="99rw6vqejz4u">
                      <span className={`mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${selected ? "border-brand" : "border-line"}`} aria-hidden="true" data-id="element-131" data-mp="1oqs4hgfhyx81">
                        {selected && <span className="h-2 w-2 rounded-full bg-brand" data-id="element-132" data-mp="3j7jt1b0oh4fb" />}
                      </span>
                      <span className="flex-1" data-id="element-133" data-mp="39fw4pizf43i2">
                        <span className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4" data-id="element-134" data-mp="39el0ji228tqf">
                          <span className="font-medium text-ink" data-id="element-135" data-mp="2vetgazkyah3z">{service.name}</span>
                          <span className="whitespace-nowrap text-sm font-medium text-ink" data-id="element-136" data-mp="30gskucsffk2i">{service.price}</span>
                        </span>
                        <span className="mt-1 block text-sm leading-relaxed text-muted" data-id="element-137" data-mp="2qh1qqc7s372y">{service.description}</span>
                        <span className="mt-2 inline-flex items-center gap-1 text-xs text-muted" data-id="element-138" data-mp="jq29rh1pxozo">
                          <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-139" data-mp="oq6p33qw4dob" />
                          {service.duration} min
                        </span>
                      </span>
                    </button>;
          })}
            </div>
          </fieldset>)}
      </div>
    </div>;
}